<template>
    <div class="component">
        <div class="label">
            {{ question.name }}
            <span v-if="question.mustAnswer" class="required">*</span>
        </div>
        <div class="upload-box">
            <p class="remark">{{ question.remark }}</p>
            <van-field :rules="rule" >
            {{rule}}
                <template #input>
                    <van-uploader
                        :disabled="disabled"
                        :deletable="!disabled"
                        :max-count="question.verifyMax"
                        v-model="fileList"
                        :after-read="handleAfterRead"
                        :before-delete="handleBeforeDelete"
                    ></van-uploader>
                </template>
            </van-field>
            <p class="des">最多上传{{ question.verifyMax }} 张</p>
        </div>
        <g-question-description v-model="show" :list="list"/>
    </div>
</template>
 
<script>
    import { uploadQiniu } from '@/utils/qiniu'
    import GQuestionDescription from "./GQuestionDescription.vue";
    export default {
        name: 'GUpload',
        components: { GQuestionDescription },
        props: ['question', 'value', 'rule',"disabled"],
        model: {
            prop: 'value',
            event: 'customInput'
        },
        computed: {
            list() {
                return this.question.remark.split('\n')
            },
            fileList: {
                deep: true,
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('customInput', val)
                    this.$emit('change')
                }
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            handleAfterRead(file, p) {
                const toast = this.$toast({
                    type: 'loading',
                    message: '上传中',
                    forbidClick: true,
                    duration: 0
                })
                uploadQiniu(
                    file.file,
                    resolve => {
                        toast.clear();
                        file.url = resolve;
                        this.$emit('customInput', this.fileList)
                        this.$emit('change')
                    },
                    () => {
                        toast.message = '上传失败';
                        this.$emit('change');
                        this.handleBeforeDelete(file, p);
                        setTimeout(() => {
                            toast.clear();
                        }, 1500)
                    },
                    progress => {
                        toast.message = Math.floor(progress) + '%'
                    }
                )
            },

            handleBeforeDelete(file, p) {
                console.log(file, p.index)
                const result = this.value.filter((photo, n) => p.index !== n);
                this.$emit('customInput', result)
                this.$emit('change')
            }
        }
    }
</script>

<style lang="less" scoped>
    .component {
        padding: 18px 16px;
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
        .des {
            padding: 0 16px 16px;
            font-size: 13px;
            font-weight: 400;
            color: #9EA2A8;
            line-height: 19px;
        }
        .remark {
            padding: 16px 16px 0;
            font-size: 13px;
            font-weight: 400;
            color: #9EA2A8;
        }
        .required {
            color: #FA3C3C;
        }
        .label {
            margin-bottom: 10px;
        }
        & > .upload-box {
            border-radius: 8px;
            overflow: hidden;
            font-size: 15px;
            background: #fff;
        }

        .van-cell {
            padding: 16px 16px 0;
            &::after{
                display: none;
            }
        }
    }
</style>
